import { Component, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './components/gs1shell/shell/shell.component';
import { ConsentBannerComponent } from './components/consent-banner/consent-banner.component';
import { ConsentService } from './services/cookie-consent.service';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';

export const RECAPTCHA_KEY = '6Lffc3sqAAAAAGXpqQOgEN-McF1PgjIjNlZ2LesQ';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [CommonModule, ShellComponent, ConsentBannerComponent, RecaptchaV3Module],
  providers: [
    ReCaptchaV3Service,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: RECAPTCHA_KEY,
    },
    ],
  standalone: true
})
export class AppComponent implements OnInit {
 @ViewChild(ConsentBannerComponent) consentBanner!: ConsentBannerComponent;
  showConsentButton = false;

  constructor(private consentService: ConsentService) {}

  ngOnInit() {
    // Mostrar o botão apenas se já existir consentimento guardado
    this.showConsentButton = this.consentService.hasAnyChoice();
    console.log('showConsentButton:', this.showConsentButton);
  }

  openConsentBanner() {
    this.showConsentButton = false;
    if (this.consentBanner) {
      this.consentBanner.open = true;
    }
  }

  onConsentBannerClosed() {
    // Mostrar o botão apenas se agora existir consentimento guardado
    this.showConsentButton = this.consentService.hasAnyChoice();
  }
}
